export const CALENDAR_PROVIDERS = [
	{
		id: 'google',
		label: 'Google Calendar',
		description: 'Sync events and tasks directly to Google Calendar.',
		logo: '/images/google-color-icon.svg',
		formName: 'SyncGoogle',
	},
	{
		id: 'outlook',
		label: 'Outlook Calendar',
		description: 'Sync events and tasks directly to Outlook Calendar.',
		logo: '/images/outlook-icon.svg',
		formName: 'SyncOutlook',
	},
	{
		id: 'ical',
		label: 'Apple Calendar (iCal)',
		description: 'Sync events and tasks directly to Apple Calendar.',
		logo: '/images/apple-icon.svg',
		formName: 'SyncIcal',
	},
]

export const isProviderConnected = (connections, providerId) => {
	const conn = connections?.[providerId]
	if (!conn) return false
	if (providerId === 'ical') return conn.connected || !!conn.feedPath
	return !!conn.connected
}

export const getDefaultSyncFromConnections = (connections) => ({
	google: isProviderConnected(connections, 'google'),
	outlook: isProviderConnected(connections, 'outlook'),
	ical: isProviderConnected(connections, 'ical'),
})
